import { render } from "./profession.vue?vue&type=template&id=70c9c6ae&scoped=true"
import script from "./profession.vue?vue&type=script&lang=js"
export * from "./profession.vue?vue&type=script&lang=js"

import "./profession.vue?vue&type=style&index=0&id=70c9c6ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c9c6ae"]])

export default __exports__